export function translateLayerContentsX(adapter, deltaX) {
    if (deltaX === 0) {
        return;
    }
    for (const shape of adapter.shapes || []) {
        const pathNodes = adapter.getPathNodes(shape);
        if (pathNodes) {
            for (const node of pathNodes) {
                node.x += deltaX;
            }
            continue;
        }
        const transform = adapter.getOrCreateComponentTransform(shape);
        if (!transform) {
            continue;
        }
        if (!transform.translation) {
            transform.translation = [0, 0];
        }
        transform.translation[0] += deltaX;
    }
    for (const anchor of adapter.anchors || []) {
        adapter.shiftAnchor(anchor, deltaX);
    }
}
